// src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import cartReducer from "./cartSlice";
import userReducer from "./userSlice";
import providerProfileReducer from "./providerProfileSlice";
import eventServiceReducer from './eventServiceSlice';
import cartbodySlice from './cartbodydataslice';
import eventcart from './eventsliceforcart';
import ordernavigation from "./orderNavigationSlice";
const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    user: userReducer,
    providerProfile: providerProfileReducer,
    eventService: eventServiceReducer,//need to persitent
    cartbodyslice: cartbodySlice,
    eventcartdata:eventcart,
    ordernavigation:ordernavigation,
  },
});

export default store;
